/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable @typescript-eslint/no-unused-vars */
import { ChevronRight, type LucideIcon } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
// import { getToken } from "@/lib/token";
import { useEffect /* useMemo */ } from "react";
// import { jwtDecode } from "jwt-decode";
// import { ADMIN_PAGES, SHARED_PAGES } from "@/app/redirctions";
// import { GenericType } from "@/types";
import { useMediaQuery } from "@/hooks/use-media-query";
import { useUserInfo } from "@/global-data/use-user-info";

export function NavMain({
  items,
}: {
  items: {
    title: string;
    url: string;
    icon?: LucideIcon;
    isActive?: boolean;
    hide?: boolean;
    key: string;
    items?: {
      title: string;
      url: string;
      key: string;
    }[];
  }[];
}) {
  const location = useLocation();
  // const token = getToken();
  const { setOpen, toggleSidebar } = useSidebar();
  // const getUser = useMemo(() => {
  //   try {
  //     const decoded: GenericType = jwtDecode(token || "");
  //     return decoded?.username;
  //   } catch (error) {
  //     return null;
  //   }
  // }, [token]);

  useEffect(() => {
    const isDetails = location.pathname
      .split("/")
      .find((item) => item === "details");

    setOpen(isDetails ? false : true);
  }, [location.pathname]);

  const matches = useMediaQuery("(max-width: 767px)");
  const { permission } = useUserInfo();

  const hasAuth = (key: string) => {
    const currentPagePermission = permission.find(
      (permissionItem) => permissionItem.name === key
    );
    return currentPagePermission?.view === true;
  };

  return (
    <SidebarGroup>
      <SidebarMenu>
        {items.map((item) => {
          const isDetails = location.pathname
            .split("/")
            .find((item) => item === "details");
          const isActive = isDetails
            ? location.pathname.startsWith(item.url)
            : location.pathname === item.url;

          if (item?.hide || !hasAuth(item.key)) {
            return null;
          }

          const url = (item as any)?.params
            ? `${item.url}${(item as any)?.params}`
            : item.url;
          return (
            <Collapsible
              key={item.title}
              asChild
              defaultOpen={item.isActive}
              className="group/collapsible"
            >
              <SidebarMenuItem>
                <CollapsibleTrigger asChild>
                  <Link
                    to={url}
                    onClick={() => {
                      if (item.url === "/document") {
                        sessionStorage.removeItem("document-page");
                        sessionStorage.removeItem("document-range");
                      }
                      if (matches) {
                        toggleSidebar();
                      }
                    }}
                  >
                    <SidebarMenuButton
                      tooltip={item.title}
                      className={cn("menu-item", {
                        "active-menu bg-white extraShadow text-sidebar-accent-foreground":
                          isActive,
                      })}
                    >
                      {item.icon && (
                        <span className="menu-icon bg-primary text-white p-1 rounded-md extraShadow">
                          <item.icon size={17} />
                        </span>
                      )}
                      <span className="text-sm font-bold text-gray_700">
                        {item.title}
                      </span>
                      {item?.items?.length ? (
                        <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                      ) : null}
                    </SidebarMenuButton>
                  </Link>
                </CollapsibleTrigger>
                <CollapsibleContent>
                  <SidebarMenuSub className="p-0">
                    {item.items?.map((subItem) => (
                      <SidebarMenuSubItem key={subItem.title}>
                        <SidebarMenuSubButton asChild>
                          <a href={subItem.url}>
                            <span>{subItem.title}</span>
                          </a>
                        </SidebarMenuSubButton>
                      </SidebarMenuSubItem>
                    ))}
                  </SidebarMenuSub>
                </CollapsibleContent>
              </SidebarMenuItem>
            </Collapsible>
          );
        })}
      </SidebarMenu>
    </SidebarGroup>
  );
}
